import { Product } from '@df/catalog/product/product';
import { ButtonsOptions, HtmlTagOptions } from '@df/ui/atomic/atomic-options';
import { NICmsContentField } from '@icms/core/content';
import { getFields as getParentFields } from '../local-model-carousel/local-model-carousel.config';
import { ILocalModelCarouselV2Data } from './local-model-carousel-v2.interface';

// TODO: (iCMS) fix `presetColors`
export function getFields(type: Product['type'] | string, pageType?: string): NICmsContentField.IField[] {
    const canShowEditorial = (data: ILocalModelCarouselV2Data) => !data?.carousel_loop;

    const fields = [
        // we can't use carousel loop when there is editorial text block
        ...getParentFields(type, pageType, true),
        // content
        <NICmsContentField.IField>{
            type: NICmsContentField.EFieldType.label,
            key: 'section-editorial',
            title: 'Editorial',
            canShow: canShowEditorial
        },
        <NICmsContentField.ITextField>{
            key: 'editorial_title',
            type: NICmsContentField.EFieldType.textarea,
            title: 'Title',
            maxLength: 20,
            canShow: canShowEditorial
        },
        <NICmsContentField.IChoiceField>{
            key: 'editorial_title_tag',
            type: NICmsContentField.EFieldType.choice,
            title: 'Force Title Tag',
            description: 'For SEO reasons you may want to force particular HTML tag',
            options: HtmlTagOptions,
            default: 'h2',
            canShow: canShowEditorial
        },
        <NICmsContentField.IField>{
            key: 'editorial_title_color',
            type: NICmsContentField.EFieldType.colorPicker,
            title: 'Title Color',
            // presetColors,
            canShow: canShowEditorial
        },
        <NICmsContentField.ITextField>{
            key: 'editorial_text',
            type: NICmsContentField.EFieldType.textarea,
            title: 'Text',
            maxLength: 180,
            canShow: canShowEditorial
        },
        <NICmsContentField.IField>{
            key: 'editorial_text_color',
            type: NICmsContentField.EFieldType.colorPicker,
            title: 'Text Color',
            // presetColors,
            canShow: canShowEditorial
        },
        <NICmsContentField.IField>{
            key: 'editorial_cta_text',
            type: NICmsContentField.EFieldType.text,
            title: 'CTA Text',
            canShow: canShowEditorial
        },
        <NICmsContentField.IField>{
            key: 'editorial_cta_link',
            type: NICmsContentField.EFieldType.text,
            title: 'CTA Link',
            description: 'If not set then it will be a collection link based on the selected category',
            canShow: canShowEditorial
        },
        <NICmsContentField.IChoiceField>{
            key: 'editorial_cta_style',
            type: NICmsContentField.EFieldType.choice,
            title: 'CTA Style',
            options: ButtonsOptions,
            canShow: canShowEditorial
        }
    ];

    return fields;
}
